/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChessKnight = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M11 2c1.579 0 3.514.251 5.093 1.088C17.734 3.958 19 5.48 19 7.858v8.316c1.165.412 2 1.52 2 2.826v3H3v-3c0-1.306.835-2.414 2-2.826v-.028l.55-.277c.87-.439 2.028-1.176 2.952-2.084.6-.59 1.043-1.194 1.285-1.785H4v-1c0-.442-.01-1.384.32-2.222.174-.44.46-.9.93-1.247C5.729 7.178 6.32 7 7 7c.115 0 .369-.053.725-.248a4.36 4.36 0 0 0 1.06-.842C9.482 5.165 10 4.15 10 3V2zM5.507 18.13A.999.999 0 0 0 5 19v1h14v-1a.999.999 0 0 0-.507-.87zm6.398-14.096c-.235 1.312-.893 2.422-1.659 3.241a6.364 6.364 0 0 1-1.56 1.23C8.162 8.792 7.572 9 7 9c-.32 0-.479.079-.563.14-.091.068-.181.181-.257.374a2.273 2.273 0 0 0-.124.486H12v1c0 1.695-1.01 3.143-2.096 4.21-.285.281-.587.544-.894.79H17V7.857c0-1.508-.734-2.414-1.843-3.002-.926-.49-2.099-.738-3.252-.82z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgChessKnight as ChessKnight };
